export const FEATURE_ANNOUNCEMENTS = [
	{
		id: 'restricted-user-role-2026',
		createdAt: '2026-11-03T00:00:00Z',
		targetRoles: ['ADMINISTRATOR'],
		badgeKey: 'featureAnnouncementNewBadge',
		titleKey: 'restrictedUserAnnouncementTitle',
		descriptionKey: 'restrictedUserAnnouncementDesc',
		asideDescriptionKey: 'restrictedUserAnnouncementAsideDesc',
		ctaLabelKey: 'restrictedUserAnnouncementCta',
		asideCtaLabelKey: 'restrictedUserAnnouncementAsideCta',
		ctaRoute: '/dashboard/users-list'
	}
];

export function getAnnouncementStorageKey(announcementId, userId) {
	return `cf_feature_announcement_dismissed_${announcementId}_${userId || 'default'}`;
}

/**
 * Returns ONLY the single latest feature announcement applicable to the current user.
 * Rule: When there are 2 or more new features to announce, ALWAYS show ONLY the latest one.
 */
export function getLatestActiveAnnouncement(profile) {
	if (!profile || !profile.role) {
		return null;
	}

	const eligible = FEATURE_ANNOUNCEMENTS.filter(item => {
		if (!item.targetRoles || item.targetRoles.length === 0) {
			return true;
		}
		return item.targetRoles.includes(profile.role);
	});

	if (eligible.length === 0) {
		return null;
	}

	// Sort chronologically and pick strictly the single latest announcement
	const sorted = [...eligible].sort(
		(a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
	);
	const latestAnnouncement = sorted[sorted.length - 1];

	try {
		const isDismissed = window.localStorage.getItem(
			getAnnouncementStorageKey(latestAnnouncement.id, profile.id)
		) === 'true';
		if (isDismissed) {
			return null;
		}
	} catch (e) {
		// Ignore storage errors
	}

	return latestAnnouncement;
}

export function dismissAnnouncement(announcementId, userId) {
	try {
		window.localStorage.setItem(
			getAnnouncementStorageKey(announcementId, userId),
			'true'
		);
		window.dispatchEvent(new Event('cf-announcement-dismissed'));
	} catch (e) {
		// Ignore storage errors
	}
}
